import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { HistoryEntry_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, union_type, record_type, string_type, option_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { API_History_CustomerHistoryWithMachine } from "../Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { SnackError } from "../ViewHelpers.js";
import { Invoice_Table_Z54DF4752 } from "../Components/InvoiceTable.js";

class Model extends Record {
    constructor(Entries, ErrorMsg) {
        super();
        this.Entries = Entries;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("MachineHistory.Model", [], Model, () => [["Entries", option_type(array_type(HistoryEntry_$reflection()))], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EntriesResponse", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("MachineHistory.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(HistoryEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(HistoryEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], []]);
}

const init = new Model(undefined, undefined);

function update(locale, model, msg) {
    if (msg.tag === 1) {
        return new Model(model.Entries, undefined);
    }
    else {
        const res = msg.fields[0];
        if (res.tag === 1) {
            return new Model(model.Entries, locale.t("History.FailedToLoad"));
        }
        else {
            return new Model(res.fields[0], model.ErrorMsg);
        }
    }
}

function fetchHistory(customerId, machineId, year) {
    let properties_2;
    const url = API_History_CustomerHistoryWithMachine(customerId, year, machineId);
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(HistoryEntry_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(HistoryEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

export function MachineHistory(machineHistoryInputProps) {
    const machineId = machineHistoryInputProps.machineId;
    const customerId = machineHistoryInputProps.customerId;
    const orderType = machineHistoryInputProps.orderType;
    const year = machineHistoryInputProps.year;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useReducer((model, msg) => update(ctx.Locale, model, msg), init);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const dependencies = [machineId, year];
    reactApi.useEffect(() => {
        console.debug("[MachineHistory] Year or customer changed: %i", year);
        const pr = fetchHistory(customerId, machineId, year);
        pr.then((arg_2) => {
            dispatch(new Message(0, [arg_2]));
        });
    }, dependencies);
    const xs = [createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(1, []));
        },
    }), createElement(Invoice_Table_Z54DF4752, {
        year: year,
        orderType: orderType,
        customerId: customerId,
        entries: unwrap(model_1.Entries),
        machineIdOpt: machineId,
    })];
    return react.createElement(react.Fragment, {}, ...xs);
}

